import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Services", id: "services", testid: "nav-link-services" },
  { label: "About", id: "about", testid: "nav-link-about" },
  { label: "Team", id: "team", testid: "nav-link-team" },
  { label: "Contact", id: "contact", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled
          ? "border-b border-sky-100 bg-white/85 shadow-[0_8px_30px_rgba(2,132,199,0.08)] backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-brand-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="group flex items-center gap-3 text-left"
        >
          <img
            src="/logo-full.png"
            alt="Directive Pathway — Education and Visa Advisory"
            className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </button>

        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="group relative text-sm font-medium text-slate-600 transition-colors hover:text-sky-700"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-sky-500 transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            data-testid="nav-cta-book-consultation"
            onClick={() => go("contact")}
            className="group flex items-center gap-2 rounded-full bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_24px_rgba(2,132,199,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-sky-500 hover:shadow-[0_12px_32px_rgba(2,132,199,0.45)]"
          >
            Get a Consultation
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <button
          data-testid="nav-mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-sky-100 bg-white/80 text-slate-700 md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-sky-100 bg-white/95 px-5 py-6 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.testid}`}
                onClick={() => go(l.id)}
                className="text-left font-display text-lg font-bold text-slate-800"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta-book-consultation"
              onClick={() => go("contact")}
              className="mt-2 rounded-full bg-sky-600 px-5 py-3 text-center text-sm font-semibold text-white"
            >
              Get a Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
